import { createSlice } from "@reduxjs/toolkit";

import { fetchConfirmedOrders } from "../../apis";

const ConfirmedOrdersSlice = createSlice({
    name: 'confirmedOrders',
    initialState: {
        isLoading: false,
        data : [],
        error: ''
    },
    extraReducers: (builder) => {
        builder.addCase(fetchConfirmedOrders.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(fetchConfirmedOrders.fulfilled, (state, action) => {
            state.isLoading = true;
            state.error = '';
            state.data = action.payload.data
        })
        builder.addCase(fetchConfirmedOrders.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
    }
})

export default ConfirmedOrdersSlice.reducer;
